// OCC option symbols ("NVDA261218C00230000": root, YYMMDD expiration, C/P,
// strike x 1000 on 8 digits), as stored by the Sweet Spot scan.

const OCC = /^([A-Z0-9.]{1,6})\s*(\d{2})(\d{2})(\d{2})([CP])(\d{8})$/;

/** { root, expiration: "YYYY-MM-DD", type: "call" | "put", strike } or null when not an OCC symbol. */
export function parseOccSymbol(symbol) {
  const m = String(symbol || "").trim().toUpperCase().match(OCC);
  if (!m) return null;
  return {
    root: m[1],
    expiration: `20${m[2]}-${m[3]}-${m[4]}`,
    type: m[5] === "P" ? "put" : "call",
    strike: Number(m[6]) / 1000,
  };
}
